export default __webpack_public_path__ + "static/media/warner_logo.0df2a662.svg";